/**
 * Triggers a file download from a URL in a new tab.
 *
 * Uses an anchor element with `target="_blank"` and the `download`
 * attribute. The server must set `Content-Disposition: attachment` so
 * the browser treats the response as a download and auto-closes the tab.
 *
 * Requires the remote server to have CORS configured when the URL
 * is cross-origin (e.g. pre-signed S3 URLs).
 */
export const downloadFileFromUrl = (url: string): void => {
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.download = ''
    link.click()
}
